// extracted by mini-css-extract-plugin
module.exports = {"videocontainer":"VideoEmbed_videocontainer__5rvre","thumbnail":"VideoEmbed_thumbnail__RW3_d","videoinnercontainer":"VideoEmbed_videoinnercontainer__uAj7M"};